import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from "react-redux";
import '@szhsin/react-menu/dist/index.css';

import store from "./store/index";
import * as Sentry from "@sentry/react";
import Clarity from '@microsoft/clarity';




import './index.css';
import App from './App';
import ErrorBoundary from './components/Other/ErrorBoundary';
import { reportClientError } from './functions/reportClientError';

Clarity.init('uecdkszr2n');
console.log(process.env.NODE_ENV);
if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://ef56d6ffd550f10641acad916a1c5be8@o4510455474028544.ingest.us.sentry.io/4510455475011584',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration()
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/adswebapp\.com/],
      // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    // Also email er@adsfo.com for every Sentry-captured frontend error
    beforeSend(event, hint) {
      const error = hint?.originalException;
      const message =
        (error && error.message) ||
        event?.message ||
        (event?.exception?.values && event.exception.values[0]?.value) ||
        'Unknown frontend error';
      const stack = (error && error.stack) || '';
      const name = (error && error.name) || event?.exception?.values?.[0]?.type;
      reportClientError({ message, stack }, name);
      return event;
    },
  });
}

// Catch non-React / promise errors even when Sentry is off (e.g. local) or misses them
window.addEventListener('error', (event) => {
  reportClientError(
    { message: event.message, stack: event.error?.stack },
    event.error?.name
  );
});
window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason;
  reportClientError({
    message: reason?.message || String(reason),
    stack: reason?.stack || '',
  }, reason?.name);
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render( 
  <Provider store={store}>
<BrowserRouter>
<ErrorBoundary>
    <App />
    </ErrorBoundary>
  </BrowserRouter></Provider>);
